import { CommonModule, NgOptimizedImage } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { CardModule } from "src/app/common/components/card/card.module";
import { ColoredBadgeModule } from "src/app/common/components/colored-badge/colored-badge.module";
import { ButtonComponent } from "src/app/shared/ui/button/button.component";
import { EneButtonModule } from "src/app/shared/ui/button/legacy/button.module";
import { WebinarsEntry } from "../../webinars/webinars.interfaces";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "tpm-contentful-card",
  templateUrl: "./contentful-card.component.html",
  styleUrls: ["./contentful-card.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    EneButtonModule,
    ColoredBadgeModule,
    CardModule,
    ButtonComponent,
    NgOptimizedImage
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentfulCardComponent {
  @Input() public isMobileView: boolean;
  @Input() public buttonLabel: string;
  @Input() public data: WebinarsEntry;

  @Output() public readonly cardClick = new EventEmitter<void>();
}
